export default "__VITE_ASSET__Hzt4Hii7__"